// src/components/CategorySkeleton.tsx
import Skeleton from 'react-loading-skeleton';
// Note: We only need to import the CSS once in our app. 
// Since ProductCardSkeleton already does it, we don't need it here.

const CategorySkeleton = () => {
  return (
    <div className="flex-shrink-0">
      {/* Image Skeleton */}
      <Skeleton className="w-28 h-28 md:w-36 md:h-36" borderRadius={12} />
      {/* Text Skeleton */}
      <Skeleton height={20} className="mt-3" />
    </div>
  );
};

export default CategorySkeleton;